<template>
  <v-card outlined flat>
    <div class="d-visit-desc_header">
      <span>{{ $t("visits.description.title") }}</span>
    </div>
    <div class="d-visit-desc_contacts">
      <span class="subtitle">
        {{ $t("visits.description.patientInformation") }}
      </span>
      <span class="d-visit-desc_contacts_name">{{ `${patientInfo.firstName} ${patientInfo.lastName}` }}</span>
      <div class="patient-info_contacts">
        <v-card-text class="patient-info_email">
          {{ patientEmail }}
        </v-card-text>
        <v-icon> mdi-circle-small </v-icon>
        <v-card-text class="patient-info_phone">
          {{ patientPhoneNumber }}
        </v-card-text>
      </div>
      <span>
        <img class="d-visit-desc_tick-icon" src="../../assets/icons/rounded-sick.svg" /><span class="subtitle"
          >{{ $t("visits.chiefComplaint") }}
        </span></span
      >
      <v-card-text class="patient-info_reason">
        {{ translateChiefComplaint(encounterNotes.chiefComplaint) }}
      </v-card-text>
      <span class="subtitle">
        {{ $t("visits.description.visitReason") }}
      </span>
      <v-card-text class="patient-info_reason">
        {{ visitDescription.complaintDescription }}
      </v-card-text>
    </div>
    <div class="d-visit-desc_mid-header">
      <span>{{ $t("visits.description.generalMedicalInformation") }}</span>
    </div>
    <div class="d-visit-desc_general">
      <div class="general-row" v-for="row in generalRows" :key="row.id">
        <p class="general-row_title">
          {{ row.title }}
        </p>
        <v-chip class="general-row-chip" label>
          {{ row.id === "isSmoking" ? translateSmokingStatus(visitDescription[row.id]) : visitDescription[row.id] }}
        </v-chip>
      </div>
    </div>
    <div v-if="visitDescription.pmh.length">
      <div class="d-visit-desc_mid-header">
        <span>{{ $t("visits.description.pastMedicalHistory") }}</span>
      </div>
      <div class="pmh-row row-height" v-for="(pmhItem, idx) in visitDescription.pmh" :key="idx" tile>
        <p>
          {{ pmhItem.name }}
        </p>
        <p>
          {{ pmhItem.year }}
        </p>
      </div>
    </div>
    <div v-if="visitDescription.allergies.length">
      <div class="d-visit-desc_mid-header">
        <span>{{ $t("visits.description.allergies") }}</span>
      </div>
      <div class="pmh-row row-height" v-for="allergy in visitDescription.allergies" :key="allergy" tile>
        <p>{{ allergy }}</p>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PractitionerVisitDescription",
  computed: {
    ...mapGetters("visitNote", [
      "patientInfo",
      "patientEmail",
      "patientPhoneNumber",
      "visitDescription",
      "encounterNotes",
    ]),
    generalRows() {
      return [
        {
          title: this.$t("general.inputs.height"),
          id: "height",
        },
        {
          title: this.$t("general.inputs.weight"),
          id: "weight",
        },
        {
          title: this.$t("settings.profile.smokingStatus"),
          id: "isSmoking",
        },
      ];
    },
  },
  methods: {
    translateChiefComplaint(val) {
      return this.$t("general.chiefComplaints")[val] || val || "-";
    },
    translateSmokingStatus(val) {
      return this.$t("general.smokingStatus")[val] || val || "-";
    },
  },
};
</script>
<style lang="scss" scoped>
.patient-info {
  padding: 20px 20px 30px 20px;

  &_email {
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    color: #2177e0;
    padding: 0;
  }

  &_phone {
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    color: $primarylight3;
    padding: 0;
  }

  &_contacts {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
  }

  &_reason {
    padding: 0;
    color: $primaryblack;
    margin-bottom: 5px;
  }
}

.general {
  padding: 20px 10px;
  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    margin-top: 10px;

    &_title {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      margin: 0;
    }

    &-chip {
      width: 50px;
      display: block;
      text-align: center;
    }
  }
}
.pmh {
  padding: 20px;
  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;

    p {
      margin: 0;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
      mix-blend-mode: normal;
      opacity: 0.5;
    }
  }
}
.row-height {
  height: 50px;
}
.subtitle {
  padding: 0;
  mix-blend-mode: normal;
  opacity: 0.4;
  margin-bottom: 10px;
}
</style>
